import { client, handleClientMethod } from "../client";
import type { DemoQuery, QueriesApiResponse } from "@onsemble/shared/types/internal";

export async function getQueries(): Promise<DemoQuery[]> {
  const response = await handleClientMethod<QueriesApiResponse>(
    client.GET("/api/internal/products/queries", {})
  );
  return response.data;
}
